<template>
	<div style="display: flex" class="small-margin-bottom">
		<div style="width: 130px;">
			<strong>{{ label }}</strong>
		</div>
		<div>
			<slot />
		</div>
	</div>
</template>

<script>
export default {
  props: [
    'label'
  ]
}
</script>
